import {GET_CAPTCHA_CONFIG, GET_SETTINGS_BY_KEYS, GET_SETTING_BY_KEY, GET_SETTING_CONFIG, GET_SETTING_CONFIG_WITH_WEB_PROJECT, GET_SETTING_WEB_SCRIPT_BY_ID} from "./_queries";
import {query} from "@core/helpers/graphql";


const get_setting_query = async (variables, options = {}) => {
    const {gql} = options;
    const result = await query(gql || GET_SETTING_BY_KEY, variables, options);

    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

const get_setting_web_script_by_id_query = async (variables, options = {}) => {
    const {gql} = options;
    const result = await query(gql || GET_SETTING_WEB_SCRIPT_BY_ID, variables, options);
    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};

const get_settings_query = async (variables, options = {}) => {
    const {gql} = options;
    const result = await query(gql || GET_SETTINGS_BY_KEYS, variables, options);

    return {
        data: result?.data,
        errors: result?.errors || false,
        status: result?.status || false,
    };
};


const get_setting_config_query = async (variables, options = {}) => {
    const { gql } = options;
    const result = await query(gql || GET_SETTING_CONFIG, variables, options);
  
    // console.log('-----------------result',result)
    return {
      data: result?.data,
      errors: result?.errors || false,
      status: result?.status || false,
    };
};

const get_captcha_config_query = async (variables, options = {}) => {
    const { gql } = options;
    const result = await query(gql || GET_CAPTCHA_CONFIG, variables, options);

    return {
      data: result?.data,
      errors: result?.errors || false,
      status: result?.status || false,
    };
};

const get_setting_config_with_web_project_query = async (variables, options = {}) => {
    const { gql } = options;
    const result = await query(gql || GET_SETTING_CONFIG_WITH_WEB_PROJECT, variables, options);
  
    // console.log('-----------------result',result)
    return {
      data: result?.data,
      errors: result?.errors || false,
      status: result?.status || false,
    };
};


export {get_captcha_config_query, get_setting_query, get_settings_query, get_setting_web_script_by_id_query, get_setting_config_query, get_setting_config_with_web_project_query};
